import {gql} from '@apollo/client';

import * as Net from 'util/Net';

export interface AgentSkillFile {
  id: string;
  virtualPath: string;
}

export interface SkillSummary {
  id: string;
  name: string;
  description: string;
  createdAt: string | null;
  isOwnedByCurrentUser: boolean;
  creatorName?: string;
  extensionDefinitionId: string | null;
  skillFiles: Array<AgentSkillFile>;
}

export const AGENT_SKILLS_QUERY = gql`
  query AgentSkillsQuery @engComponent(name: LLM) @skipAudit {
    agentSkills {
      id
      name
      description
      createdAt
      creatorId
      creatorName
      extensionDefinitionId
      skillFiles {
        id
        virtualPath
      }
    }
  }
`;

export const AGENT_SKILL_FILE_QUERY = gql`
  query AgentSkillFileQuery($id: StrictString!) @engComponent(name: LLM) @skipAudit {
    agentSkillFile(id: $id) {
      id
      virtualPath
      s3LocationId
      presignedUrl
    }
  }
`;

export interface AgentSkillFileQueryData {
  agentSkillFile: {
    id: string;
    virtualPath: string;
    presignedUrl: string | null;
  } | null;
}

export interface AgentSkillFileQueryVariables {
  id: string;
}

export interface AgentSkillsQueryData {
  agentSkills: Array<{
    id: string;
    name: string;
    description: string;
    createdAt: string;
    creatorId: string | null;
    creatorName: string | null;
    extensionDefinitionId: string | null;
    skillFiles: Array<AgentSkillFile>;
  }>;
}

export function bulkCreateSkills(s3Locations: Array<string>): Promise<{skillIds: Array<string>}> {
  return Net.postJSONPromise({
    url: '/1/api/llm/agent-skills:bulk-create',
    data: {s3Locations},
  });
}

export function updateSkill(
  skillId: string,
  updates: {name?: string; description?: string}
): Promise<{skillId: string}> {
  return Net.patchJSONPromise({url: `/1/api/llm/agent-skills/${skillId}`, data: updates});
}

export async function archiveSkill(skillId: string, reason?: string): Promise<void> {
  await Net.postJSONPromise({
    url: `/1/api/llm/agent-skills/${skillId}:archive`,
    data: {reason: reason ?? ''},
  });
}

export async function unarchiveSkill(skillId: string): Promise<void> {
  await Net.postJSONPromise({url: `/1/api/llm/agent-skills/${skillId}:unarchive`, data: {}});
}
